// Import the functions you need from the SDKs you need
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyC21T7_-LkPsjL_X5u0lwJzNMrLN4g8dCQ',
  authDomain: 'cyder-ai.firebaseapp.com',
  projectId: 'cyder-ai',
  storageBucket: 'cyder-ai.appspot.com',
  messagingSenderId: '194107596421',
  appId: '1:194107596421:web:b18cc129c6859ca26193ec',
  measurementId: 'G-J9X6PP543D',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const functions = getFunctions(app, 'https://internal-api.betterfunnel.ai');
const auth = getAuth(app);
const storage = getStorage();

// connectFunctionsEmulator(functions, 'localhost', 5001);

export { analytics, app, auth, db, functions, storage };
